var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Instagram = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("path", { fill: background, className: "ic_background", d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M25.45 33.142c4.24 0 7.69-3.45 7.69-7.69V15.23c0-4.24-3.45-7.688-7.689-7.688h-10.22c-4.24 0-7.69 3.448-7.69 7.688v10.222c0 4.24 3.45 7.689 7.69 7.689h10.22z" }),
            React.createElement("path", { fill: background, className: "ic_background", d: "M15.226 9.942h10.23a5.291 5.291 0 0 1 5.285 5.284v10.23a5.291 5.291 0 0 1-5.286 5.285H15.226a5.29 5.29 0 0 1-5.285-5.285v-10.23a5.291 5.291 0 0 1 5.285-5.285z" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M20.34 13.942c-3.528 0-6.4 2.87-6.4 6.4 0 3.528 2.872 6.4 6.4 6.4 3.53 0 6.4-2.872 6.4-6.4 0-3.53-2.87-6.4-6.4-6.4z" }),
            React.createElement("path", { fill: background, className: "ic_background", d: "M20.34 24.342c-2.205 0-4-1.796-4-4 0-2.207 1.795-4 4-4 2.206 0 4 1.793 4 4 0 2.204-1.794 4-4 4z" }),
            React.createElement("path", { fill: background, className: "ic_background", d: "M26.4 12a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2z" }))));
};
Instagram.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Instagram;
//# sourceMappingURL=Instagram.js.map